import moment from 'moment';

export function timestampToDate(timestamp) {
  const month = getMonthToTimestamp(timestamp);
  const day = timestamp.toDate().getDate() < 10 ? `0${timestamp.toDate().getDate()}` : timestamp.toDate().getDate();
  return `${day}/${month}/${timestamp.toDate().getFullYear()}`;
}

function getMonthToTimestamp(timestamp) {
  return timestamp.toDate().getMonth() + 1 < 10 ? `0${timestamp.toDate().getMonth() + 1}` : timestamp.toDate().getMonth() + 1;
}

export function dateToString(date) {
  const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  return `${day}/${month}/${date.getFullYear()}`;
}

export function dateToStringYMD(date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  return `${year}${month}${day}`;
}

export const getFullDateAsString = (date = new Date()) => {
  const fullDateFormat = 'YYYYMMDDHHmmss';
  return moment(date).format(fullDateFormat);
};

export function dateToStringWithHour(date) {
  const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  const hour = `${date.getHours()}:${date.getMinutes()}`;
  return `${day}/${month}/${date.getFullYear()} ${hour}`;
}

export const dateToMMDDYYYY = (date) => {
  return moment(date).format('MM-DD-YYYY');
};

export const dateToYYYYMMDD = (date) => {
  return moment(date).format('YYYYMMDD');
};

export const todayToYYYYMMDD = () => {
  return dateToYYYYMMDD(Date.now());
};

export const dateToFullDateTime = (date) => {
  const dateTimeFormat = 'YYYY-MM-DDTHH:mm:ss';
  return moment(date).format(dateTimeFormat);
};

export const stringToDate = (str) => {
  return moment(str).toDate();
};

export const dateToMDYHM = (date) => {
  return moment(date).format('M/D/YYYY h:mm a');
};

export const dateToLL = (date) => {
  return moment(date).format('LL');
};

export const startDayOfDate = (date) => {
  return moment(new Date(date)).startOf('day').toDate();
};

export const endDayOfDate = (date) => {
  return moment(new Date(date)).endOf('day').toDate();
};

export const dateToFullLongDateTime = (date) => {
  return moment(date).format('MMMM Do YYYY, h:mm:ss a');
};

export const daysFromDateToToday = (dateInThePast) => {
  var currentDate = moment(new Date().toISOString());
  return currentDate.diff(dateInThePast, 'days');
};

export const dateToMMMMDoYYYY = (date) => {
  return moment(date).format('MMMM Do YYYY');
};

export const dateStringYMDtoDate = (dateString) => {
  const year = dateString.substring(0, 4);
  const yearNumber = parseInt(year);
  const month = dateString.substring(4, 6);
  const monthNumber = parseInt(month) - 1;
  const day = dateString.substring(6, 8);
  const dayNumber = parseInt(day);
  //ignore timezone
  return new Date(yearNumber, monthNumber, dayNumber, 0, 0, 0, 0);
};

export const generateRangeDate = (startDateString, endDateString) => {
  let res = [];

  const startDate = dateStringYMDtoDate(startDateString);
  const endDate = dateStringYMDtoDate(endDateString);
  let currentDate = startDate;

  while (currentDate.getTime() <= endDate.getTime()) {
    res.push(dateToStringYMD(currentDate));
    //Add one day to generate the range
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return res;
};
